import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { useCallback } from 'react';
import AgGridTable from 'src/app/main/utilities/AgGridTable';
import moment from "moment";
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import uploadMultipleFilePopup from '../upload-component/uploadMultipleFilePopup';
import CustomDatePicker from 'src/app/main/utilities/CustomDatePicker';

/* -------------------------------- birthDate -------------------------------- */
const birthDate = forwardRef((props, ref) => {
    const refBirthDatePicker = useRef();
    const [birthDate, setBirthDate] = useState(null);

    const handleBirthDateChange = (newValue) => {
        setBirthDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.birthDate) {
            setBirthDate(props.data.birthDate);
        }
    }, [props.data])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (birthDate !== null) {
                    return moment(birthDate).format('YYYY-MM-DD');
                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'birthDate'}
            maxDate={new Date()}
            value={birthDate ? birthDate : (!props.value ? null : props.value)}
            handleChange={handleBirthDateChange}
            ref={refBirthDatePicker}
        />
    );
});

const familyData = [
    { relation: "Father", name: "", type: "", birthDate: "", attachFile: "" },
    { relation: "Mother", name: "", type: "", birthDate: "", attachFile: "" },
    { relation: "Brother", name: "", type: "", birthDate: "", attachFile: "" },
]

const relation = ["Father", "Mother", "Brother", "Sister"]

const FamilyDetail = ({ personalInfo,setSnackState, setSuccessMsg }) => {
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    const [familyInfo, setFamilyInfo] = useState(familyData);
    const [uploadDocument, setUploadDocument] = useState([]);

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const [familyColumnDefs, setFamilyColumnDefs] = useState([
        { field: 'file', enableRowGroup: false, hide: true, editable: false },
        {
            field: 'relation', enableRowGroup: true, cellEditor: 'agSelectCellEditor', cellEditorParams: {
                values: relation,
            }
        },
        { field: 'name', enableRowGroup: true },
        { field: 'documentType', enableRowGroup: true },
        { field: 'birthDate', enableRowGroup: true, cellEditor: birthDate, cellRenderer: handleDateFormat },
        {
            field: 'uploadFile', enableRowGroup: true, cellEditor: uploadMultipleFilePopup, cellStyle: {
                textAlign: 'right',
            }
        }
    ]);

    const onGridReady = useCallback((params) => {
        setGridApi(params);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [familyInfo]);


    /*------------------------------Inline Row editing options-------------------------------*/

    const onBtAdd = useCallback((event) => {
        const newRow = {}
        // const RowIndex = event.node.rowIndex + 1;
        // let index = documentsFile.findIndex((row) => row.id === event.node.data.id);
        // const nextIndex = index + 1;
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        familyInfo.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'relation')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'relation',
            });
        }, 800);
    }, [familyInfo]);
    const onBtStartEditing = useCallback((event) => {
        const index = event?.node?.rowIndex >= 0 ? event?.node?.rowIndex : event?.api?.getSelectedRows().length > 0 && familyInfo.findIndex((row) => JSON.stringify(row) === JSON.stringify(event?.api?.getSelectedRows()[0]));
        gridRef.current.api.setFocusedCell(index, 'relation')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'relation',
        });

    }, [familyInfo]);

    // const onBtCopyRow = useCallback((event) => {
    // }, []);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        const index = event?.node?.rowIndex >= 0 ? event?.node?.rowIndex : event?.api?.getSelectedRows().length > 0 && familyInfo.findIndex((row) => JSON.stringify(row) === JSON.stringify(event?.api?.getSelectedRows()[0]));
        familyInfo.splice(index, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
    }, [gridApi, familyInfo])

    const getContextMenuItems = (event) => {
        const data = event?.node?.data || event.api?.getSelectedRows().length > 0;
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            // {
            //     name: "Copy Row",
            //     icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
            //     action: () => {
            //         onBtCopyRow(event);
            //     },
            // },
            {
                name: "Delete Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        const uploadFiles = data.file.map((file) => file.name);
        const model = {
            relation: data.relation,
            name: data.name,
            documentType: data.documentType,
            birthDate: data.birthDate,
            empId: personalInfo.employeeId,
            File: data.file,
            uploadFiles: uploadFiles
        }
        if (uploadDocument.length > 0) {
            if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                const updatedData = uploadDocument.map((item) => {
                    if (item.rowIndex === event.node.rowIndex) {
                        item.relation = data.relation;
                        item.name = data.name;
                        item.documentType = data.documentType;
                        item.birthDate = data.birthDate;
                        item.empId = personalInfo.employeeId;
                        item.File = data.file;
                    }
                    return item;
                })
                setUploadDocument(updatedData);
            } else {
                setUploadDocument([...uploadDocument, model]);
            }
        } else {
            setUploadDocument([...uploadDocument, model]);
        }
    }, [uploadDocument, personalInfo]);

    const handleSubmit = async () => {
        try {
            if (uploadDocument.length === 0) {
                setSuccessMsg("Please fill all field");
                setSnackState(true);
                setTimeout(() => { setSnackState(false) }, 2000);
            } else{
                await Promise.all(uploadDocument.map(async (upload, index) => {
                    try {
                        const formData = new FormData();
                        formData.append('relation', upload.relation);
                        formData.append('name', upload.name);
                        formData.append('documentType', upload.documentType);
                        formData.append('birthDate', upload.birthDate);
                        formData.append('empId', upload.empId);
                        upload?.File?.map((item) => {
                            formData.append('File', item);
                        })
                        upload?.uploadFiles?.map((item) => {
                            formData.append('uploadFiles', item);
                        })

                        const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.uploadFamilyDocument}`
                        if (url) {
                            await OAuthService.uploadFile(url, formData).then(res=>{
                                if (res.status === 200) {
                                    setSuccessMsg("Family Informational Documents Saved Successfully !!!");
                                    setSnackState(true);
                                    setTimeout(() => {
                                        setSnackState(false)
                                    }, 2000);
                                }
                            }).catch(e=>{
                                setSuccessMsg(e.message);
                                setSnackState(true);
                                setTimeout(() => {
                                    setSnackState(false)
                                }, 2000);
                            });
                        }
                    } catch (error) {
                        console.log('error', error);
                    }
                }))
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div>
            <div>
                <div className='flex justify-end mb-16'>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="warning"
                    >
                        <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                        Save Document
                    </Button>
                </div>
            </div>
            <div style={{ height: "500px" }}>
                <AgGridTable
                    columnDefs={familyColumnDefs}
                    rowData={familyInfo}
                    onGridReady={onGridReady}
                    //   onSelectionChanged={onSelectionChanged}
                    //   onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    editable={true}
                    editType={'fullRow'}
                    paginationPageSize={10}
                    onRowValueChanged={onRowValueChanged}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'familyInfo'}
                />
            </div>
        </div>
    )
}

export default FamilyDetail